import { AdvertisingServiceInterface } from 'domain/services';
import {
  AdvertisingListUseCaseInterface,
  AdvertisingCreateUseCaseInterface,
  AdvertisingUpdateUseCaseInterface,
  AdvertisingDeleteUseCaseInterface,
} from 'domain/usecases';

export class AdvertisingService implements AdvertisingServiceInterface {
  constructor(
    private readonly _advertisingUpdate: AdvertisingUpdateUseCaseInterface,
    private readonly _advertisingCreate: AdvertisingCreateUseCaseInterface,
    private readonly _advertisingList: AdvertisingListUseCaseInterface,
    private readonly _advertisingDelete: AdvertisingDeleteUseCaseInterface,
  ) {}

  advertisingUpdate(
    params: AdvertisingUpdateUseCaseInterface.Params,
  ): Promise<AdvertisingUpdateUseCaseInterface.Result> {
    return this._advertisingUpdate.execute(params);
  }

  advertisingCreate(
    params: AdvertisingCreateUseCaseInterface.Params,
  ): Promise<AdvertisingCreateUseCaseInterface.Result> {
    return this._advertisingCreate.execute(params);
  }

  advertisingList(
    params: AdvertisingListUseCaseInterface.Params,
  ): Promise<AdvertisingListUseCaseInterface.Result[]> {
    return this._advertisingList.execute(params);
  }
  advertisingDelete(
    params: AdvertisingDeleteUseCaseInterface.Params,
  ): Promise<AdvertisingDeleteUseCaseInterface.Result> {
    return this._advertisingDelete.execute(params);
  }
}
